import { Component, Input, OnChanges, SimpleChanges, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { buildPublicExperienceStyles } from '../../../services/global.service';
import { Product, ProductDesignTemplatePageModuleDataContent } from '../../../store/app.model';
import { QrProductFeedback } from '../../../store/app.actions';
import { Store } from '@ngxs/store';
import { ActivatedRoute } from '@angular/router';
import { NotificationService } from '../../../services/notification.service';
import { FormsModule } from '@angular/forms';
import { LineBreakPipe } from '../../../pipes/line-break.pipe';

@Component({
  selector: 'app-form',
  imports: [CommonModule, ButtonModule, FormsModule, LineBreakPipe],
  templateUrl: './form.component.html',
})
export class FormComponent implements OnChanges {
  // @Input({ required: true }) content!: ProductDesignTemplatePageContent;
  @Input({ required: true }) content!: any;
  @Input({ required: true }) styles!: any;
  @Input({ required: true }) isSelectedModule!: boolean;
  @Input({ required: true }) isFirstModule!: boolean;
  @Input({ required: true }) isLastModule!: boolean;
  @Input({ required: true }) product!: Product;

  items: ProductDesignTemplatePageModuleDataContent[] = [];
  tenantId: string = 'regenesis';
  firstname: string = '';
  lastname: string = '';
  email: string = '';
  phone: string = '';
  message: string = '';

  private readonly store = inject(Store);
  private readonly route = inject(ActivatedRoute);
  private readonly notificationService = inject(NotificationService);

  constructor() {
    this.tenantId = this.route.snapshot.queryParams['x-tenant-id'] || 'regenesis';
  }

  ngOnChanges(_changes: SimpleChanges): void {
    if (this.content) {
      if (
        'pageModuleTemplateDataContents' in this.content &&
        Array.isArray(this.content.pageModuleTemplateDataContents)
      ) {
        this.items = this.content.pageModuleTemplateDataContents;
      } else if (
        'contentItems' in this.content &&
        Array.isArray(this.content.contentItems)
      ) {
        this.items = this.content.contentItems;
      } else if (
        'components' in this.content &&
        Array.isArray(this.content.components)
      ) {
        this.items = this.content.components;
      } else {
        this.items = [];
      }
    } else {
      this.items = [];
    }
  }

  filter(array: any[] | undefined | null, column: any, value: any) {
    if (!array) return [];
    return array.filter(item => item[column] === value);
  }

  buildStyle(type: string, style: any): string {
    return buildPublicExperienceStyles(type, style);
  }

  submitForm() {
    if (this.firstname === '' || this.lastname === '' || this.email === '' || this.message === '' || this.phone === '') {
      return;
    }
    this.store.dispatch(
      new QrProductFeedback({
        type: 'FORM',
        qrProductItemId: this.product.qrProductItem.id,
        response: {
          firstname: this.firstname,
          lastname: this.lastname,
          email: this.email,
          phone: this.phone,
          message: this.message,
        },
      }, this.tenantId)
    ).subscribe(() => {
      this.notificationService.openSuccessToast("Your response has been submitted successfully!")
    })
  }
}
